module.exports = __webpack_public_path__ + "img/303.yellow.0780b918.gif";